import { Flame, MapPin, Phone } from "lucide-react";
import { ORDER_URL } from "@/components/Navbar";
import { scrollToSection } from "@/App";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy grain relative text-cream pt-20 pb-28 lg:pb-10 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/assets/kababish-logo.jpg"
              alt="Kababish Calamvale logo"
              className="h-14 w-14 rounded-full object-cover ring-1 ring-gold/60"
            />
            <div>
              <p className="font-heading text-2xl font-semibold">Kababish</p>
              <p className="text-[10px] tracking-[0.3em] uppercase text-gold">Calamvale</p>
            </div>
          </div>
          <p className="mt-5 text-cream/60 font-light leading-relaxed text-sm max-w-xs">
            Authentic Pakistani &amp; Indian cuisine — charcoal kebabs, biryanis,
            curries and naan from the tandoor, made fresh daily.
          </p>
        </div>

        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5">Explore</p>
          <div className="flex flex-col gap-3">
            {[
              { label: "Home", t: "#home" },
              { label: "About Us", t: "#about" },
              { label: "Gallery", t: "#gallery" },
              { label: "Contact Us", t: "#contact" },
            ].map((l) => (
              <button
                key={l.label}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => scrollToSection(l.t)}
                className="text-left text-cream/70 hover:text-gold transition-colors duration-300 text-sm w-fit"
              >
                {l.label}
              </button>
            ))}
            <a
              data-testid="footer-link-menu"
              href={ORDER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-cream/70 hover:text-gold transition-colors duration-300 text-sm w-fit"
            >
              Menu
            </a>
          </div>
        </div>

        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5">Visit Us</p>
          <div className="flex flex-col gap-4 text-sm text-cream/70">
            <p className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-gold" />
              Shop 10/2605 Beaudesert Rd, Calamvale QLD 4116
            </p>
            <a href="tel:+61408382360" data-testid="footer-phone-link" className="flex items-center gap-3 hover:text-gold transition-colors duration-300">
              <Phone size={16} className="shrink-0 text-gold" />
              +61 408 382 360
            </a>
            <a
              data-testid="footer-order-btn"
              href={ORDER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 flex w-fit items-center gap-2 bg-spice hover:bg-[#a91f1f] transition-colors duration-300 text-cream font-semibold px-6 py-3 rounded-full"
            >
              <Flame size={15} />
              Order Online
            </a>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-cream/40">
          © {new Date().getFullYear()} Kababish Calamvale. All rights reserved.
        </p>
        <p className="font-script text-gold/70 text-lg">fire · spice · soul</p>
      </div>
    </div>
  </footer>
);

export default Footer;
